export default __webpack_public_path__ + "static/media/kids.84ced35c.svg";